import { Pipe, PipeTransform } from '@angular/core';
import { RadioGroupOptionInterface } from '../components/radio-group/interfaces';

@Pipe({
  name: 'optionsWithHits',
  pure: false
})
export class OptionsWithHitsPipe implements PipeTransform {
  transform(options: RadioGroupOptionInterface[]): RadioGroupOptionInterface[] {
    return options.filter(item => item.hits > 0);
  }
}
